import store from "@/store";

export class ProductTool {
  constructor() {
    this.productData = store.state.productData;
    this.initProductData();
  }

  initProductData = () => {
    this.productData = this.productData.map((product) => {
      let tmpProduct = Object.assign({}, product);

      if (tmpProduct.Tags == "") {
        tmpProduct.Tags = [];
      } else {
        tmpProduct.Tags = product.Tags.split(",");
      }
      const discountData = this.getProductDiscount(product);
      tmpProduct.Discount = discountData.discountList;
      tmpProduct.DiscountTypeList = discountData.discountTypeList;
      tmpProduct.OptionPicture = tmpProduct.Picture.filter(
        (item) => item.ColorID != "0" || item.Size != "0"
      );
      tmpProduct.MinPriceStock = this.getProductMinPriceStock(product);
      tmpProduct.SellStatus = this.getProductSellStatus(product);

      return tmpProduct;
    });

    // 檢查this.productData中的資料將SellStatus!=normal的商品排到最後
    this.productData = this.productData.sort((a, b) => {
      if (a.SellStatus == "normal" && b.SellStatus != "normal") {
        return -1;
      }
      if (a.SellStatus != "normal" && b.SellStatus == "normal") {
        return 1;
      }
      return 0;
    });
  };

  getProductDiscount(product) {
    const discountTypeTextList = {
      P: "打折",
      D: "免運",
      G: "贈品",
      S: "組合價",
      F: "折扣",
    };
    let discountList = JSON.parse(JSON.stringify(product.Discount));

    discountList = discountList.map((discount) => {
      let tmpDiscount = Object.assign({}, discount);
      tmpDiscount.DiscountTypeText =
        discountTypeTextList[discount.DiscountType];
      return tmpDiscount;
    });

    let discountTypeList = [];
    discountList.forEach((discount) => {
      if (!discountTypeList.includes(discount.DiscountTypeText)) {
        discountTypeList.push(discount.DiscountTypeText);
      }
    });

    return {
      discountList: discountList,
      discountTypeList: discountTypeList,
    };
  }

  getSortProductData = (
    sortType = "default",
    category = "all",
    keyword = ""
  ) => {
    let productData = JSON.parse(JSON.stringify(this.productData));
    productData = productData.map((product) => {
      product.Menu = product.Menu.filter((menu) => {
        return menu.Status == "Y";
      });
      return product;
    });
    if (category != "all") {
      productData = productData.filter(
        (product) =>
          product.Menu.filter((menu) => menu.MenuID == category).length > 0
      );
    }
    if (keyword != "") {
      productData = productData.filter((item) => {
        let keywordList = keyword.split(" ");
        let isMatch = false;
        keywordList.forEach((keyword) => {
          if (item.Title.toUpperCase().includes(keyword.toUpperCase())) {
            isMatch = true;
          }
        });
        return isMatch;
      });
    }

    switch (sortType) {
      case "priceUp":
        return productData.sort((a, b) => {
          return b.MinPriceStock.SellPrice - a.MinPriceStock.SellPrice;
        });

      case "priceDown":
        return productData.sort((a, b) => {
          return a.MinPriceStock.SellPrice - b.MinPriceStock.SellPrice;
        });

      case "timeUp":
        return productData.sort((a, b) => {
          return new Date(a.created_at) - new Date(b.created_at);
        });

      case "timeDown":
        return productData.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });

      default:
        return productData;
    }
  };

  getProductSellStatus(product) {
    let totalStock = 0;
    if (product.IsCustom != "Y") {
      product.Stock.forEach((stock) => {
        if (stock.Status == "Y") {
          totalStock += parseInt(stock.Stock);
        }
      });
    } else {
      totalStock = product.CustomGoodsStock[0].Stock;
    }
    if (totalStock <= 0) {
      return "已售完";
    }

    if (product.GoodsTimeStart != null) {
      let startTime = new Date(product.GoodsTimeStart);
      let endTime = new Date(product.GoodsTimeEnd);
      let now = new Date();
      if (now < startTime) {
        return "尚未開賣";
      }
      if (now > endTime) {
        return "已結束販售";
      }
    }

    return "normal";
  }

  getProductMinPriceStock(product) {
    let minPriceStock = null;
    if (product.IsCustom != "Y") {
      product.Stock.forEach((stock) => {
        if (stock.Status == "Y") {
          if (
            minPriceStock == null ||
            stock.SellPrice < minPriceStock.SellPrice
          ) {
            minPriceStock = stock;
          }
        }
      });
    } else {
      minPriceStock = product.CustomGoodsStock[0];
    }
    return minPriceStock;
  }
}
